define(
    'Born_Midtrans/js/action/select-payment-method',[
        'Magento_Checkout/js/model/quote',
        'Magento_Checkout/js/model/full-screen-loader',
        'jquery',
        'Magento_Checkout/js/action/get-totals',
    ],
    function (quote, fullScreenLoader, jQuery, getTotalsAction) {
        'use strict';
        return function (paymentMethod) {
            if (paymentMethod && paymentMethod.method !== "mapclub") {
                quote.paymentMethod(paymentMethod);
                fullScreenLoader.startLoader();
                jQuery.ajax('/binpromotion/checkout/validatebinpromotion', {
                    data: {cc_number: '', payment_method: paymentMethod.method},
                    complete: function () {
                        getTotalsAction([]);
                        fullScreenLoader.stopLoader();
                    }
                });
            }else if (paymentMethod && paymentMethod.method == "mapclub") {
                quote.paymentMethod(paymentMethod);
                getTotalsAction([]);
            }
        }
    }
);

